export default function userAuthHeader() {
    let user = JSON.parse(localStorage.getItem("sportips_auth_user"));
    if (user && user.token) {
        return { Authorization: 'Bearer ' + user.token };
    }
    else {
        return {};
    }
}